import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "./router";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileCTA from "@/components/feature/MobileCTA";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <Navbar />
      <AppRoutes />
      <Footer />
      <MobileCTA />
    </BrowserRouter>
  );
}
